<template>
<div  class="container-fluid" >
  
  <div class="card ">
  <div class="card-header text-white bg-primary">    
      <h4><i  class="fas fa-list-alt mr-2" aria-hidden="true"></i>LISTA PRODOTTI PER PROMO  {{promo.description}}</h4>    
  </div>
  
  <div class="card-body"> 
  
   <div class="row">
   <div class="col"> 

  <div v-if="paramsType" class="card border-info" >
    <div class="card-header bg-info"><strong><i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
      PARAMETRI DI RICERCA</strong>
    </div>

  <div class="card-body ">
  <div v-if="paramsType" class="form-group">


    <div class="row">
      <button @click="$emit('close')" type="button"   class="btn btn-secondary float-left  mb-4 mr-4 ml-3">                    
        <i style="color:yellow" class="fas fa-reply ml-2 mr-2" aria-hidden="true"></i>
        RITORNA A LISTA PROMOZIONI
      </button>  

      <button type="button" @click ="setParams()" class="btn btn-primary mb-4 mr-3" data-toggle="button" aria-pressed="false">        
        <i style="color:yellow" class="	fas fa-sync-alt mr-2" aria-hidden="true"></i>
        ALTRI PARAMETRI DI RICERCA
      </button>  
    </div>



    <div class="accordion" id="accordionExample">
    <div class="card">
    <div class="card-header" id="headingOne">
      <h2 class="mb-0">
        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        RICERCA PER CODICE A BARRE
        </button>
      </h2>
    </div>

    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
      <div class="card-body">
        <form class="" v-on:submit.prevent="getDataByBarcode()">
          
          <div class="col-auto mr-4">
            <label class="" for="barcode"><strong>
              <i style="color:black" class="fas fa-barcode mr-2" aria-hidden="true"></i>
              CODICE A BARRE PRODOTTO</strong></label>      
            <input required v-focus type="number"  class="form-control " id="barcode" autocomplete="off" placeholder="Digitare un codice a barre prodotto e premere invio." v-model="barcode">
            <small id="codeBlock" class="form-text text-muted">
              Formato ammesso EAN13.
            </small>
          </div>
         
        </form>


        
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header" id="headingTwo">
      <h2 class="mb-0">
        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
          CARICAMENTO PRODOTTI DA FILE
        </button>
      </h2>
    </div>
    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
      <div class="card-body">

        <div class="col-auto ml-4">
            <label ><strong>TIPO DI FILE</strong></label>
            <div class="form-check">
            <input class="form-check-input" type="radio" name="exampleRadios0" id="exampleRadios0" value="1"  v-model="file_typeId" checked>
            <label class="form-check-label" for="exampleRadios0">
              SOLO BARCODE  
            </label>
        </div>
        <div class="form-check">
        <input class="form-check-input" type="radio" name="exampleRadios1" id="exampleRadios1" value="2" v-model="file_typeId">
        <label class="form-check-label" for="exampleRadios1">
          BARCODE,SCONTO
        </label>
        </div>
        <div class="form-check">
        <input class="form-check-input" type="radio" name="exampleRadios2" id="exampleRadios2" value="3" v-model="file_typeId">
        <label class="form-check-label" for="exampleRadios2">
          BARCODE,PREZZO DI VENDITA
        </label>
        </div>
         <div class="form-check">
        <input class="form-check-input" type="radio" name="exampleRadios3" id="exampleRadios3" value="4" v-model="file_typeId">
        <label class="form-check-label" for="exampleRadios3">
          PRODOTTO,SCONTO
        </label>
        </div>




            <div v-if="bt_spinner1">
              <span class="spinner-border text-primary spinner-border-sm ml-2" role="status" aria-hidden="true"></span>   
            </div>
            <div v-else>
              <input-file  @update="getDataFromFile" v-bind:type="'PriceListUpdate'" v-bind:typeId="file_typeId"></input-file> 
            </div>            
        </div>

       
      </div>
    </div>
  </div>
  <div v-if="1==0" class="card">
    <div class="card-header" id="headingThree">
      <h2 class="mb-0">
        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
          Collapsible Group Item #3
        </button>
      </h2>
    </div>
    <div  id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
      <div class="card-body">
        And lastly, the placeholder content for the third and final accordion panel. This panel is hidden by default.
      </div>
    </div>
  </div>
</div>









    <div v-if="1==0" class="form-row align-items-center">
        <form class="" v-on:submit.prevent="getDataByBarcode()">
          
          <div class="col-auto mr-4">
            <label class="" for="barcode"><strong>
              <i style="color:black" class="fas fa-barcode mr-2" aria-hidden="true"></i>
              CODICE A BARRE PRODOTTO</strong></label>      
            <input required v-focus type="number"  class="form-control " id="barcode" autocomplete="off" placeholder="Digitare un codice a barre prodotto e premere invio." v-model="barcode">
            <small id="codeBlock" class="form-text text-muted">
              Formato ammesso EAN13.
            </small>
          </div>
         
        </form>

        <div v-if="1==0" class="col-auto ml-4">
            <label ><strong>CARICAMENTO DA FILE</strong></label>
            <div class="form-check">
            <input class="form-check-input" type="radio" name="exampleRadios0" id="exampleRadios0" value="1"  v-model="file_typeId" checked>
            <label class="form-check-label" for="exampleRadios0">
              SOLO BARCODE  
            </label>
        </div>
        <div class="form-check">
        <input class="form-check-input" type="radio" name="exampleRadios1" id="exampleRadios1" value="2" v-model="file_typeId">
        <label class="form-check-label" for="exampleRadios1">
          BARCODE,SCONTO
        </label>
        </div>

        <div class="form-check">
        <input class="form-check-input" type="radio" name="exampleRadios2" id="exampleRadios2" value="3" v-model="file_typeId">
        <label class="form-check-label" for="exampleRadios2">
          BARCODE,PREZZO DI VENDITA
        </label>
        </div>

        <div class="form-check">
        <input class="form-check-input" type="radio" name="exampleRadios3" id="exampleRadios3" value="4" v-model="file_typeId">
        <label class="form-check-label" for="exampleRadios3">
          PRODOTTO,SCONTO
        </label>
        </div>




            <div v-if="bt_spinner1">
              <span class="spinner-border text-primary spinner-border-sm ml-2" role="status" aria-hidden="true"></span>   
            </div>
            <div v-else>
              <input-file  @update="getDataFromFile" v-bind:type="'PriceListUpdate'" v-bind:typeId="file_typeId"></input-file> 
            </div>            
        </div>

    </div>
    <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

    </div>

    <!-- BODY 1 BLOCK-->  
    </div>

    <products v-if="type=='B' && items.length > 0" v-bind:products="items" v-bind:promoId="promoId" v-bind:show_btn="true" @reset="items=[]"></products>
    <productsFromFile v-if="type == 'C' && items.length > 0" v-bind:products="items" v-bind:promoId="promoId" v-bind:file_typeId="file_typeId"   @close="type='A'" ></productsFromFile>  
  <!-- CARD PARAMS BLOCK 1 -->      
  </div>   

  <div v-else>

    <div v-if="type=='A'">
    <div class="card border-info" >
    <div class="card-header bg-info"><strong><i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
      PARAMETRI DI RICERCA</strong>
    </div>

    <div class="card-body ">
      <div class="row">
        <button @click="$emit('close')" type="button"   class="btn btn-secondary float-left  mb-4 mr-4 ml-3">                    
          <i style="color:yellow" class="fas fa-reply ml-2 mr-2" aria-hidden="true"></i>
          RITORNA A LISTA PROMOZIONI
        </button>  

        <button type="button" @click ="paramsType=!paramsType" class="btn btn-primary mb-4 mr-3" data-toggle="button" aria-pressed="false">
          <i style="color:yellow" class="	fas fa-sync-alt mr-2" aria-hidden="true"></i>
          ALTRI PARAMETRI DI RICERCA
        </button>  
      </div> 
      <form name="productSearch" v-on:submit.prevent="getDataByParams()">

        <category-grouping v-bind:required="true"  v-bind:isActive="true" @update="setGroupCategoryId"></category-grouping>  
        <season-select v-bind:required="true"  v-bind:type="true"  v-bind:isActive="true" @update="setSeasonId"></season-select>      
        <year-select v-bind:_label="label1" v-bind:_year="0" v-bind:optionBase="true" v-bind:isActive="true" @update="setYearStart"></year-select>      
        <year-select  _id="0" v-bind:_label="label2" v-bind:_year="0" v-bind:optionBase="true" v-bind:isActive="true" @update="setYearEnd"></year-select>      

        <department-select v-bind:required="true" v-bind:type="true"  v-bind:isActive="true" @update="setDepartmentId"></department-select>  

        <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>             
        <supplier-brand-list :key="refresh"  v-bind:props="brand" @update="setBrandId"></supplier-brand-list>
        <category-select v-bind:props="category"  @update="setCategoryId"></category-select>   

        <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

        <button :disabled="bt_spinner1"  class="btn btn-primary float-right mr-2 " type="submit">
          <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
              CERCA
            <span v-if="bt_spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
        </button>

      </form>
    </div>
  </div>
</div>

<div v-else>
  <div class="row">
     
     <button @click="$emit('close')" type="button"   class="btn btn-secondary float-left  mb-4 mr-4 ml-3">                    
         <i style="color:yellow" class="fas fa-reply ml-2 mr-2" aria-hidden="true"></i>
         RITORNA A LISTA PROMOZIONI
       </button>  
 
       <button type="button" @click ="type='A',items=[]" class="btn btn-success mb-4 mr-3" data-toggle="button" aria-pressed="false">
         RITORNA A PARAMETRI DI RICERCA
       </button>  
  </div> 
  <products  v-if="type == 'D'" v-bind:products="items" v-bind:promoId="promoId"   @close="type='A'"></products>
  
</div>

<!-- --> 
</div>

</div>
</div>
</div>
</div>  






</div>

</template>
<script>

import api                 from "@/api";

import alertBox          from '@/components/common/AlertBox.vue'
import supplierSelect    from '@/components/common/SupplierSelect_1.vue';
import supplierBrandList from '@/components/common/SupplierBrandSelect_1.vue'
import categoryGrouping  from '@/components/common/CategoryGroupingSelect.vue';
import categorySelect    from '@/components/common/CategorySelect_1.vue';
import departmentSelect  from '@/components/common/DepartmentSelect.vue';
import seasonSelect      from '@/components/common/SeasonSelect.vue';
import yearSelect        from '@/components/common/YearSelect.vue';
import inputFile         from '@/components/common/InputFile.vue';
import products          from '@/components/frontOffice/PromoItemsTable.vue'
import productsFromFile  from '@/components/frontOffice/PromoItemsTableFromFile.vue'

import {mapGetters }    from 'vuex';


export default {
  props      : ['promoId'],
  components  : {
    alertBox, supplierSelect, categoryGrouping, categorySelect,
    departmentSelect, seasonSelect, yearSelect, inputFile, supplierBrandList, products,productsFromFile
    
},
  data() {
    return {
      file_typeId     : 1,
      type            : 'A',    
      category        : 
      {
        Id            : 0,
        isActive      : true,        
        optionBase    : true,
        required      : false,
        groupId       : 0
       
      },  
      supplier        : 
      {
        Id            : 0,
        isActive      : true,       
        optionBase    : true,
        required      : false

      },
      brand           :
      {
        supplierId    : 0,
        Id            : '%',
        required      : false,
        allBrands     : true

      },  
      refresh         : 0,
      paramsType             : true,
      barcode                : '',
      product                : {},
      items                  : [],

      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
      bt_spinner1             : false, 
      promo                  : {},
      label1                 : 'da ',
      label2                 : 'ad ',
     
    }
  },
  computed :{
   
     ...mapGetters(['company']),
     
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted : function()
  {
    $('#collapseOne').on('shown.bs.collapse', () => {
      $('#barcode').trigger('focus')
      this.items = []
      
      
      
})
$('#collapseTwo').on('shown.bs.collapse',  () => {
            
      //document.getElementById("exampleRadios0").checked = true;
      this.items = []
})
    this.getPromo()    
  },
  created: function() 
  {
    
  },

  methods: {


  async getProductVariants(products) {
      this.bt_spinner1 = true        
      const data     = 
      {
        'products'   : products
      } 

      const sp      = {'sp':'spBarcodesListPerProduct'}
      const json    = Object.assign(data, sp)
      
      return new Promise(async (resolve, reject) =>  {
         await api.post(json).then(res => {
          this.bt_spinner1 = false          
          if(res.status==200)
            {
                           
                
                resolve(res.data.recordsets[0])

            }
            else if (res.status==500)
            {
              
              
            }
          
          else
          {
            
            
          }
      }).catch(err=>{
        
            
      
      })
      
      
    })
  },
    


  setParams()
  {
    this.paramsType  = !this.paramsType
    this.items       = []
    this.msg.title   = ''
    this.type        = 'A'
    this.file_typeId = 1
  },  
  async getDataFromFile(barcodes) {
       
        let arr_items  = []
        if(barcodes.length == 0)
        {
          return
        }
        const items = barcodes 
        this.items = []
        this.msg.title = ''      
        
        
        if(this.file_typeId == 4)
        {
          arr_items = await this.getProductVariants(items)
         
          const data  = 
          {
            'companyId'     : this.company.Id,
            'barcodes'      : arr_items,
            'promoId'       : this.promoId,  
            'file_typeId'   : this.file_typeId
          } 
        
          this.getData(data,true)  

        }
        else
        {
          // remove Duplicates
        arr_items = items.filter(
          (obj, index) =>
            items.findIndex((item) => item.barcode === obj.barcode) === index
          );

        
        const data  = 
        {
          'companyId'     : this.company.Id,
          'barcodes'      : arr_items,
          'promoId'       : this.promoId,  
          'file_typeId'   : this.file_typeId
         } 
        
        this.getData(data,true)  
        }
        
             
        
        
    
},

    getDataByBarcode()
    {
      const barcode = this.barcode.substring(0, 13);
      
      const data  = 
      {
        'companyId'     : this.company.Id,
        'barcode'       : barcode,
        'promoId'       : this.promoId  
      } 
      
      this.getData(data,false)
      this.barcode = ''

    },
    getDataByParams()
    {
      
      const data     = 
      {
      
        'companyId'     : this.company.Id ,
        'promoId'       : this.promoId,
        'categoryId'    : this.product.CategoryId,     
        'seasonId'      : this.product.SeasonId,
        'departmentId'  : this.product.DepartmentId,
        
        'grpCategoryId' : this.product.GroupCategoryId,
        'supplierId'    : this.supplier.Id,
        'yearStart'     : this.product.YearStart,
        'yearEnd'       : this.product.YearEnd,
        'brandId'       : this.brand.Id,
        'file_typeId'   : this.file_typeId
        
      } 

      
      this.getData(data,true)

    },
    
    setSupplierId(supplierId)
    {       
      this.supplier.Id = supplierId
      this.brand.supplierId = supplierId
      this.refresh++      
    },      
    setGroupCategoryId(Id)
    {
      this.product.GroupCategoryId = Id
    },
    setCategoryId(Id)
    {
      this.product.CategoryId = Id
    },
    setDepartmentId(Id)
    {
      this.product.DepartmentId = Id
    },
    setSeasonId(Id)
    {
      this.product.SeasonId = Id
    },
    setYearStart(year)
    {
      this.product.YearStart = year
    },
    setYearEnd(year)
    {
      this.product.YearEnd = year
    },
    setBrandId(brandId)
    {
      this.brand.Id = brandId
    },

    async getData(data,reset) {
      
      this.msg.title = ''      
    
      this.bt_spinner1 = true
      if(reset)
      {
        this.items   = []
      }

     let sp = {'sp':'spPromoProductSearch'}
     if(this.file_typeId > 1)
     {
        sp = {'sp':'spPromoProductsListFromFile'}
     }
    
     const json    = Object.assign(data, sp)
         
         await api.post(json).then(res => {
          if(res.status==200)
            {           
             
              if(res.data.recordsets[0].length==0)
              { 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
                return
              }
    
              if(reset)
              {
                this.items = res.data.recordsets[0]     
                                      
                if(this.paramsType)
                {
                  this.type = this.file_typeId < 2 ? 'B' : 'C'  
                 
                }
                else
                {
                  this.type = 'D'
                }
                
              }
              else
              {
                
                let found = 0
                const productId = res.data.recordsets[0][0].productId
                
                this.items.forEach(item => {
                  if(item.productId == productId)
                  {
                    found ++
                  }
                })
                
                if(found == 0)
                {
                  this.items.push(res.data.recordsets[0][0])
                  this.type = 'B'
                }
                
              }
             
            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      }).finally(() => {
            this.bt_spinner1 = false
            
        });
      
      
      

    },

async getPromo() {
              
      const data     = 
      {
        'promoId'   : this.promoId,
      } 

      const sp = {'sp':'spPromo'}
      const json    = Object.assign(data, sp)
         await api.post(json).then(res => {
                    
          if(res.status==200)
            {
                           
              if(res.data.recordsets[0].length==0)
              { 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }
              
              this.promo     = res.data.recordsets[0][0]

            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.bt_spinner1 = false
      

    },
    

   
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}



.pointer:hover
{
  _background-color   : darkorchid;
  _color              : white;
  cursor             : pointer;
}



.table-wrapper-scroll-y {
display: block;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }


 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 18px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}

.form-check-label{
  cursor:pointer
}
</style>